import type { FilterState } from '@/types/lead-attribution'
import type { JobberRequestsQuery } from '@/features/jobber/types'

const serializeDateRange = (filters: FilterState) =>
  filters.dateRange
    ? {
        start: filters.dateRange.start.toISOString(),
        end: filters.dateRange.end.toISOString(),
      }
    : undefined

const serializeFilters = (filters: FilterState) => ({
  ...filters,
  dateRange: serializeDateRange(filters),
})

export const jobberQueryKeys = {
  base: ['jobber'] as const,
  jobDetails: (jobId: string | undefined, franchise: string) =>
    ['jobber', 'job-details', jobId, franchise] as const,
  requests: {
    all: ['jobber', 'requests'] as const,
    list: (query: JobberRequestsQuery) => ['jobber', 'requests', 'list', query] as const,
    todayByCity: (city: string) => ['jobber', 'requests', 'today', city] as const,
  },
  syncStats: (filters: FilterState) =>
    ['jobber', 'sync-stats', serializeFilters(filters)] as const,
  metrics: {
    all: ['jobber', 'metrics'] as const,
    dashboard: (filters: FilterState) => ['jobber', 'metrics', 'dashboard', serializeFilters(filters)] as const,
  },
  crm: {
    customers: ['jobber', 'customers'] as const,
    jobs: ['jobber', 'jobs'] as const,
  },
  integrationStatus: () => ['jobber', 'integrations', 'status'] as const,
}

export type JobberQueryKeys = typeof jobberQueryKeys
